// extracted by mini-css-extract-plugin
export default {"node":"styles_node__7JEMg","content":"styles_content__gXDuJ","textContainer":"styles_textContainer__B6XX1","text":"styles_text__l5NUt"};